import { axios } from "../core/axios.interceptor";

export async function getTokenFromAuthCode(state, connectionRequest) {    
  const response = await axios.post(`?state=${state}`, connectionRequest);
  return response;
}
